// src/routes/ProtectedShell.js
import React from "react";
import { Outlet } from "react-router-dom";
import { SocketProvider } from "./UniversalComponents/SocketContext";

export default function ProtectedShell() {
  return (
    <SocketProvider>
      <Outlet />
    </SocketProvider>
  );
}
